import { Injectable, EventEmitter } from '@angular/core';
import { SignalRService, SignalREventService, ToastrService, Project, DataArray, LoggingService} from './../index';

@Injectable()
export class ProjectService {
    public ProjectChange: EventEmitter<ProjectService[]> = new EventEmitter<ProjectService[]>();
    public allProjectChange: EventEmitter<Project[]> = new EventEmitter<Project[]>();
    public projectUpdate: EventEmitter<Project> = new EventEmitter<Project>();

    public projects: DataArray<Project> = new DataArray<Project>();
    constructor(
        private _signalRService: SignalRService,
        private _signalREventService: SignalREventService,
        private _toastrService: ToastrService,
        private _loggingService: LoggingService,
    ) {
        this.registerOnServerEvents();
    }
    public Create_Project(Title: any): Promise<any> {
        return this._signalRService.invoke('Create_Project', Title, Number(localStorage.getItem('User_ID'))).then((result: any) => {
            return result;
    });
    }
    public LockStagingTab(): Promise<any> {
        return this._signalRService.invoke('LockStagingTab', Number(localStorage.getItem('User_ID'))).then((result: any) => {
            return result;
        });
    }
    public GetStagingTabStatus(Live: boolean): Promise<any>  {
        return this._signalRService.invoke('GetStagingTabStatus', Live, Number(localStorage.getItem('User_ID'))).then((result: any) => {
            return result;
        });
    }
    private onCreateProject(info: any): void {
        this._toastrService.displayToastrMessage('success', 'Project ' + info.Data.Company.Project_Title + ' has been created!', 'Create Project');
    }
    public delete(): any {
        return this._signalRService.invoke('Reset_Staging_Environment', Number(localStorage.getItem('User_ID'))).then((result: any) => {
            this._signalRService.invoke('GetCompanies', false);
            this._signalRService.invoke('FilterModels', '', true, true, false, [], [], []);
            this._signalRService.invoke('getMinesitesStaging');
            return result;
        });
    }
    public Reset_Staging_Environment_Forced_Unlock(): any {
        return this._signalRService.invoke('Reset_Staging_Environment_Forced_Unlock', Number(localStorage.getItem('User_ID'))).then((result: any) => {
            this._signalRService.invoke('GetCompanies', false);
            this._signalRService.invoke('FilterModels', '', true, true, false, [], [], []);
            this._signalRService.invoke('getMinesitesStaging');
            return result;
        });
    }
    public Delete_Project_Details(Project_ID: number, Status: string, ID: number): Promise<any> {
        return this._signalRService.invoke('Delete_Projects_Details', Project_ID, Status, ID).then((result: any) => {
            return result;
        });
    }
    public Publish_Project_Details(): Promise<any> {
        this._loggingService.log(`projectService.Publish_Project_Details: userId: ${Number(localStorage.getItem('User_ID'))}`);
        return this._signalRService.invoke('Publish_Project_Details', Number(localStorage.getItem('User_ID'))).then((result: any) => {
            this._loggingService.log(`projectService.Publish_Project_Details : Run GetCompanies, FilterModels, GetMinesitesStaging: result: ${result}`);
            this._signalRService.invoke('GetCompanies', false);
            this._signalRService.invoke('FilterModels', '', true, true, false, [], [], []);
            this._signalRService.invoke('getMinesitesStaging');
            return result;
        });
    }
    public Delete_Project(Project_ID: number): Promise<any> {
        return this._signalRService.invoke('Delete_Project', Project_ID).then((result: any) => {
            return result;
        });
    }
    public SnapShot_Restore(Date: any, LastDate: any): Promise<any> {
        return this._signalRService.invoke('SnapShot_Restore', Date, LastDate, Number(localStorage.getItem('User_ID')) ).then((result: any) => {
            return result;
        });
    }
    public update(Project_ID: number, Project_Title: string): void {
        this._signalRService.invoke('UpdateProjects', Project_ID, Project_Title, Number(localStorage.getItem('User_ID')));
    }
    public Get_All_Projects_With_Details(): Promise<any> {
        return this._signalRService.invoke('Get_All_Projects_With_Details').then((result: any) => {
            return result;
        });
    }
    public Get_Company_Under_Project(val: any): void {
        if (Number(val) == 0) {
            this._signalRService.invoke('GetCompanies', false);
            this._signalRService.invoke('FilterMinesites', '', true, true, false, [], [], [], []);
            this._signalRService.invoke('FilterModels', '', true, true, false, [], [], []);
        }
        else {
            this._signalRService.invoke('Get_Company_Under_Project', Number(val));
            this._signalRService.invoke('Get_Minesite_Under_Project', Number(val));
            this._signalRService.invoke('Get_Models_Under_Project', Number(val));
        }
    }
    private onAllProject(info: any): void {
        const proj: Project = null;
        for (const item of info.Data.projects) {
            const proj: Project = $.extend(new Project(), item);
            this.projects.update(proj, true);
        }
        this.allProjectChange.emit(this.projects.Data);
    }
    private onUpdateProjects(info: any): void {
        const project: Project = $.extend(new Project(), info.Data.Project);
        this.projects.update(project);
        this.projectUpdate.emit(project);
    }
    private onDeleteProjects(info: any): void {
        this._toastrService.displayToastrMessage('success', 'Project ' + info.Project_Title + ' has been deleted!', 'Delete Project');
       // this.Get_All_Projects();
    }
    private registerOnServerEvents() {
        this._signalREventService.register('ProjectService', 'createproject', (info: any) => this.onCreateProject(info));
        this._signalREventService.register('ProjectService', 'projects', (info: any) => this.onAllProject(info));
        this._signalREventService.register('ProjectService', 'updateproject', (info: any) => this.onUpdateProjects(info));
        this._signalREventService.register('ProjectService', 'deleteprojects', (info: any) => this.onDeleteProjects(info));
    }
    public deregisterOnServerEvents(): void {
        this._signalREventService.deregister('ProjectService');
    }
}
